<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 320 320">
    <!-- <symbol id="icon-large-loading" viewBox="0 0 100 100">
      <title>large loading</title>
      <g>
        <animateTransform attributeName="transform" begin="0s" dur="1s" type="rotate" from="0 160 160" to="360 160 160" repeatCount="indefinite"/>
        <path d="M0 50c0-27.5 22.5-50 50-50s50 22.5 50 50c0 5-3.333 8.333-8.333 8.333s-8.333-3.333-8.333-8.333c0-18.333-15-33.333-33.333-33.333s-33.333 15-33.333 33.333c0 18.333 15 33.333 33.333 33.333 5 0 8.333 3.333 8.333 8.333s-3.333 8.333-8.333 8.333c-27.5 0-50-22.5-50-50z"></path>
      </g>
    </symbol> -->
  </svg>
</template>

<script>
export default {

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/reuse/lordlessSvg/animation.vue